import { render, staticRenderFns } from "./App.vue?vue&type=template&id=56f5599e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./css/common.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./App.vue?vue&type=style&index=1&id=56f5599e&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports